/**
 * Enum representing tooltip labels for various actions in the application.
 */
export enum TooltipLabel {
	/** Tooltip label for clearing the current selection. */
	CLEAR_SELECTION = 'Clear selection',

	/** Tooltip label for stopping the editing process. */
	STOP_EDITING = 'Stop editing',

	/** Tooltip label for starting the editing process. */
	START_EDITING = 'Start editing',

	/** Tooltip label for stopping the drawing process. */
	STOP_DRAWING = 'Stop drawing',

	/** Tooltip label for starting the drawing process. */
	START_DRAWING = 'Start drawing',
}